export const DRAWER_ON_BENEFIT_CARD = 0;
export const DRAWER_ON_MY_BENEFITS = 1;
export const DRAWER_ON_REVIEW = 2;
export const DRAWER_ON_BENEFIT_MOBILE_CARD = 3;
